import { ReactNode, useMemo } from 'react';

// material-ui
import {useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, AppBarProps } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

// project-imports
import AppBarStyled from './AppBarStyled';


import IconButton from 'components/@extended/IconButton';
import useConfig from 'hooks/useConfig';

// assets
import { HambergerMenu } from 'iconsax-react';

// typs
import { LAYOUT_CONST } from 'types/config';
import StudentHeaderContent from './HeaderContent/StudentNavBar2';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

interface Props {
  open: boolean;
  handleDrawerToggle?: () => void;
  hideDrawer: boolean;
  isStudent: boolean;
  handleAiChat?: () => void;
}

const Header = ({ open, handleDrawerToggle, hideDrawer, isStudent, handleAiChat }: Props) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down(1266));
  const { menuOrientation } = useConfig();
  const { user } = useAuth();

  const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

  // header content
  const studentHeaderContent = useMemo(() => <StudentHeaderContent hideDrawer={hideDrawer} isStudent={isStudent} handleAiChat={handleAiChat} />, [handleAiChat]);

  const iconBackColorOpen = 'secondary.200';
  const iconBackColor = theme.palette.mode === 'dark' ? 'background.default' : 'secondary.100';

  // common header
  const mainHeader: ReactNode = (
    <Toolbar id="header-nav" sx={{ boxShadow: '4'}}>  
      <style>
        {user?.type === 'student'
          ? `.MuiToolbar-root{
        padding-left:0px !important;
        padding-right:0px !important;
        padding-top:0px !important;
        padding-bottom:0px !important;
        margin-bottom:0px !important;
        min-height:0px !important;
      }`
          : ``}
      </style>
      {!isHorizontal && !hideDrawer ? (
        <IconButton
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          variant="light"
          size="large"
          sx={{ color: 'secondary.main', bgcolor: open ? iconBackColorOpen : iconBackColor, ml: { xs: 0, lg: -2 }, p: 1 }}
        >
          <HambergerMenu />
        </IconButton>
      ) : null}
      {studentHeaderContent}
    </Toolbar>
  );

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    elevation: 0,
    sx: {
      bgcolor:'#063B9A',
      backdropFilter: 'blur(8px)',
      zIndex: 1200
      
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

export default Header;
